import escaladeCover from "@/assets/escalade/cover-tighter.webp.asset.json";
import rangeRover0663 from "@/assets/range-rover/dsc_0663_matched.webp.asset.json";
import rangeRover0669 from "@/assets/range-rover/dsc_0669_matched.webp.asset.json";
import rangeRover0670 from "@/assets/range-rover/dsc_0670.webp.asset.json";
import rangeRover0672 from "@/assets/range-rover/dsc_0672.webp.asset.json";
import rangeRover0673 from "@/assets/range-rover/dsc_0673.webp.asset.json";
import rangeRover0674 from "@/assets/range-rover/dsc_0674.webp.asset.json";
import rangeRover0679 from "@/assets/range-rover/dsc_0679.webp.asset.json";
import rangeRover0678 from "@/assets/range-rover/dsc_0678.webp.asset.json";
import rangeRover0677 from "@/assets/range-rover/dsc_0677.webp.asset.json";
import rangeRover0676 from "@/assets/range-rover/dsc_0676.webp.asset.json";
import rangeRover0675 from "@/assets/range-rover/dsc_0675.webp.asset.json";
import rangeRover0684 from "@/assets/range-rover/dsc_0684.webp.asset.json";
import rangeRover0688 from "@/assets/range-rover/dsc_0688.webp.asset.json";
import rangeRover0687 from "@/assets/range-rover/dsc_0687.webp.asset.json";
import rangeRover0686 from "@/assets/range-rover/dsc_0686.webp.asset.json";
import rangeRover0690 from "@/assets/range-rover/dsc_0690.webp.asset.json";
import rangeRover0689 from "@/assets/range-rover/dsc_0689.webp.asset.json";
import rangeRover0692 from "@/assets/range-rover/dsc_0692_v6.webp.asset.json";
import rangeRover0699 from "@/assets/range-rover/dsc_0699_matched.webp.asset.json";
import rangeRover0705 from "@/assets/range-rover/dsc_0705_matched.webp.asset.json";
import escFront from "@/assets/escalade/front-satin-black.webp.asset.json";
import escSide from "@/assets/escalade/side-satin-black.webp.asset.json";
import escWheel from "@/assets/escalade/wheel-satin-black.webp.asset.json";
import escRear from "@/assets/escalade/rear-satin-black.webp.asset.json";
import escTrunkUpright from "@/assets/escalade/trunk-upright-new.webp.asset.json";
import escTrunkFolded from "@/assets/escalade/trunk-folded-new.webp.asset.json";
import escNewThirdRow from "@/assets/escalade/third-row-new.webp.asset.json";
import escMirror from "@/assets/escalade/mirror-new.webp.asset.json";
import escPassengerDash from "@/assets/escalade/passenger-dash-new.webp.asset.json";
import escMiddleRow from "@/assets/escalade/middle-row-new.webp.asset.json";
import escDoor from "@/assets/escalade/door.webp.asset.json";
import escDoorDetail from "@/assets/escalade/door-detail.webp.asset.json";
import escInterior from "@/assets/escalade/interior.webp.asset.json";
import escFrontCabin from "@/assets/escalade/front-cabin.webp.asset.json";
import escDash from "@/assets/escalade/dash.webp.asset.json";
import escRearSeats from "@/assets/escalade/rear-seats.webp.asset.json";
import escThirdRow from "@/assets/escalade/third-row.webp.asset.json";
import escSunroof from "@/assets/escalade/sunroof.webp.asset.json";
import x7Front from "@/assets/x7/01-front.webp.asset.json";
import x7Side from "@/assets/x7/02-side.webp.asset.json";
import x7RearQuarter from "@/assets/x7/03-rear-quarter.webp.asset.json";
import x7Rear from "@/assets/x7/04-rear.webp.asset.json";
import x7FrontDetail from "@/assets/x7/05-front-detail.webp.asset.json";
import x7Wheel from "@/assets/x7/06-wheel.webp.asset.json";
import x7CabinRear from "@/assets/x7/07-cabin-rear.webp.asset.json";
import x7RearSeatsSide from "@/assets/x7/08-rear-seats-side.webp.asset.json";
import x7RearHeadrests from "@/assets/x7/09-rear-headrests.webp.asset.json";
import x7Cockpit from "@/assets/x7/10-cockpit.webp.asset.json";
import x7PassengerDash from "@/assets/x7/11-passenger-dash.webp.asset.json";
import x7Console from "@/assets/x7/12-console.webp.asset.json";
import x7DriverCockpit from "@/assets/x7/13-driver-cockpit.webp.asset.json";
import x7Door from "@/assets/x7/14-door.webp.asset.json";
import x7PanoCabin from "@/assets/x7/15-pano-cabin.webp.asset.json";
import x7Headrest from "@/assets/x7/16-headrest.webp.asset.json";
import x7CargoFlat from "@/assets/x7/17-cargo-flat.webp.asset.json";
import x7ThirdRowSide from "@/assets/x7/18-thirdrow-side.webp.asset.json";
import x7Forward from "@/assets/x7/19-forward.webp.asset.json";
import sclassFront from "@/assets/sclass/01_front_zoom2.webp.asset.json";
import sclassSide from "@/assets/sclass/02_side.webp.asset.json";
import sclassRear from "@/assets/sclass/03_rear.webp.asset.json";
import sclassWheel from "@/assets/sclass/04_wheel.webp.asset.json";
import sclassDriverDoor from "@/assets/sclass/05_driver_door.webp.asset.json";
import sclassRearDoor from "@/assets/sclass/06_rear_door.webp.asset.json";
import sclassRearSeats from "@/assets/sclass/07_rear_seats.webp.asset.json";
import sclassTrunkInt from "@/assets/sclass/09_trunk_interior.webp.asset.json";
import sclassDash from "@/assets/sclass/10_dash.webp.asset.json";
import sclassFrontAlt from "@/assets/sclass/11_front_alt.webp.asset.json";
import sclassRearPano from "@/assets/sclass/12_rear_pano.webp.asset.json";
import sclassRearDoorInt from "@/assets/sclass/13_rear_door_int.webp.asset.json";
import sclassRearPano2 from "@/assets/sclass/14_rear_pano2.webp.asset.json";
import sclassCockpit from "@/assets/sclass/15_cockpit.webp.asset.json";
import sclassConsole from "@/assets/sclass/17_console.webp.asset.json";
import sclassPassengerDoor from "@/assets/sclass/18_passenger_door.webp.asset.json";
import macanFront from "@/assets/macan/01-front.webp.asset.json";
import macanSide from "@/assets/macan/02-side.webp.asset.json";
import macanRearQuarter from "@/assets/macan/03-rear-quarter.webp.asset.json";
import macanRear from "@/assets/macan/04-rear.webp.asset.json";
import macanTrunk from "@/assets/macan/05-trunk.webp.asset.json";
import macanDoor from "@/assets/macan/06-door.webp.asset.json";
import macanFrontCabin from "@/assets/macan/07-front-cabin.webp.asset.json";
import macanConsole from "@/assets/macan/08-console.webp.asset.json";
import macanPassenger from "@/assets/macan/09-passenger.webp.asset.json";
import macanRearSeats from "@/assets/macan/10-rear-seats.webp.asset.json";
import macanExteriorSide from "@/assets/macan/11-exterior-side.webp.asset.json";
import macanExteriorRear from "@/assets/macan/12-exterior-rear.webp.asset.json";
import macanDriverView from "@/assets/macan/13-driver-view.webp.asset.json";
import macanConsoleDetail from "@/assets/macan/14-console-detail.webp.asset.json";
import macanPassengerDash from "@/assets/macan/15-passenger-dash.webp.asset.json";
import macanFrontCenter from "@/assets/macan/16-front-center.webp.asset.json";
import macanFrontQuarterClose from "@/assets/macan/17-front-quarter.webp.asset.json";
import m3Asset from "@/assets/car-m3.webp.asset.json";
const m3 = m3Asset.url;

import m440Front from "@/assets/m440/01-front.webp.asset.json";
import m440Side from "@/assets/m440/02-side.webp.asset.json";
import m440Rear from "@/assets/m440/03-rear.webp.asset.json";
import m440RearSeats from "@/assets/m440/04-rear-seats.webp.asset.json";
import m440Door from "@/assets/m440/05-door.webp.asset.json";
import m440Cockpit from "@/assets/m440/06-cockpit.webp.asset.json";
import m440PassengerDash from "@/assets/m440/07-passenger-dash.webp.asset.json";
import m440CenterDash from "@/assets/m440/08-center-dash.webp.asset.json";
import m440Infotainment from "@/assets/m440/09-infotainment.webp.asset.json";
import m440Console from "@/assets/m440/10-console.webp.asset.json";
import m440RearQuarter from "@/assets/m440/11-rear-quarter.webp.asset.json";
import x1 from "@/assets/car-x1.webp";
import x1Side from "@/assets/x1/side.webp.asset.json";
import x1FrontQuarter from "@/assets/x1/front-quarter.webp.asset.json";
import x1Front from "@/assets/x1/front.webp.asset.json";
import x1Wheel from "@/assets/x1/wheel.webp.asset.json";
import x1Interior from "@/assets/x1/interior.webp.asset.json";
import x1DriverView from "@/assets/x1/driver-view.webp.asset.json";
import x1Dash from "@/assets/x1/dash.webp.asset.json";
import x1Door from "@/assets/x1/door.webp.asset.json";
import x1Sunroof from "@/assets/x1/sunroof.webp.asset.json";
import x1Trunk from "@/assets/x1/trunk.webp.asset.json";
import x1RearSeats from "@/assets/x1/rear-seats.webp.asset.json";

export type CarRates = {
  h24: string;
  h48: string;
  d36: string;
  d7: string;
  kmIncluded: string;
  extraKm: string;
  security: string;
  ldw: string;
};

export type Car = {
  slug: string;
  name: string;
  shortName: string;
  tagline: string;
  image: string;
  images?: string[];
  category: string;
  pricePerDay: number;
  specs: { label: string; value: string }[];
  specNote?: string;
  description: string;
  rates: CarRates;
};

const inventory: Car[] = [
  {
    slug: "cadillac-escalade-2023",
    name: "2023 Cadillac Escalade",
    shortName: "Cadillac Escalade",
    tagline: "Imposing presence, executive comfort",
    image: escaladeCover.url,
    images: [
      escaladeCover.url,
      escFront.url,
      escSide.url,
      escRear.url,
      escWheel.url,
      escInterior.url,
      escDash.url,
      escPassengerDash.url,
      escDoorDetail.url,
      escMirror.url,
      escFrontCabin.url,
      escMiddleRow.url,
      escRearSeats.url,
      escSunroof.url,
      escThirdRow.url,
      escNewThirdRow.url,
      escTrunkUpright.url,
      escTrunkFolded.url,
    ],
    category: "Full-size Luxury SUV",
    pricePerDay: 395,
    specs: [
      { label: "Engine", value: "3.0L Diesel" },
      { label: "Seats", value: "7" },
      { label: "Colour", value: "Satin Black" },
      { label: "Drive", value: "4WD" },
    ],
    description:
      "The Escalade is the definitive statement SUV. Satin Black with a blacked-out grille and wheels, paired with a cavernous, screen-lined interior built for executives, athletes, and entourages.",
    rates: {
      h24: "$395/day",
      h48: "$295/day",
      d36: "$250/day",
      d7: "$225/day",
      kmIncluded: "150 km/day",
      extraKm: "$1.75/km over 150 km",
      security: "$2,000",
      ldw: "$60/day",
    },
  },
  {
    slug: "range-rover-p530-lwb-2024",
    name: "2024 Range Rover P530 LWB",
    shortName: "Range Rover P530 LWB",
    tagline: "Long-wheelbase comfort, unmistakable presence",
    image: rangeRover0692.url,
    images: [
      rangeRover0692.url,
      rangeRover0699.url,
      rangeRover0663.url,
      rangeRover0669.url,
      rangeRover0705.url,
      rangeRover0670.url,
      rangeRover0679.url,
      rangeRover0674.url,
      rangeRover0672.url,
      rangeRover0673.url,
      rangeRover0675.url,
      rangeRover0676.url,
      rangeRover0677.url,
      rangeRover0678.url,
      rangeRover0688.url,
      rangeRover0686.url,
      rangeRover0687.url,
      rangeRover0690.url,
      rangeRover0684.url,
      rangeRover0689.url,
    ],
    category: "Full-size Luxury SUV",
    pricePerDay: 395,
    specs: [
      { label: "Engine", value: "4.4L Twin-Turbo V8" },
      { label: "Horsepower", value: "523 hp" },
      { label: "Seats", value: "7" },
      { label: "Interior", value: "Black" },
      { label: "Drive", value: "AWD" },
    ],
    description:
      "The long-wheelbase Range Rover pairs seven seats and a black interior with the smooth power of a twin-turbo V8. Finished in dark paint with black wheels, it brings quiet, commanding comfort to airport arrivals, family trips, and longer drives out of Vancouver.",
    rates: {
      h24: "$395/day",
      h48: "$295/day",
      d36: "$275/day",
      d7: "$250/day",
      kmIncluded: "150 km/day",
      extraKm: "$1.75/km over 150 km",
      security: "$2,000",
      ldw: "$60/day",
    },
  },
  {
    slug: "bmw-x7-m60i-2024",
    name: "2024 BMW X7 M60i",
    shortName: "BMW X7 M60i",
    tagline: "V8 flagship SUV, uncompromising power",
    image: x7Front.url,
    images: [
      x7Front.url,
      x7Side.url,
      x7RearQuarter.url,
      x7Rear.url,
      x7FrontDetail.url,
      x7Wheel.url,
      x7Cockpit.url,
      x7DriverCockpit.url,
      x7PassengerDash.url,
      x7Console.url,
      x7Door.url,
      x7Headrest.url,
      x7CabinRear.url,
      x7RearSeatsSide.url,
      x7RearHeadrests.url,
      x7PanoCabin.url,
      x7ThirdRowSide.url,
      x7Forward.url,
      x7CargoFlat.url,
    ],
    category: "Full-size Performance SUV",
    pricePerDay: 295,
    specs: [
      { label: "Engine", value: "4.4L Twin-Turbo V8" },
      { label: "Horsepower", value: "523 hp" },
      { label: "Seats", value: "6" },
      { label: "Drive", value: "xDrive AWD" },
    ],
    specNote: "Equipped with captain seats in the middle row.",
    description:
      "The X7 M60i is BMW's ultimate three-row SUV. A thundering V8, sport-tuned suspension, and every luxury appointment, built for those who refuse to compromise.",
    rates: {
      h24: "$295/day",
      h48: "$275/day",
      d36: "$250/day",
      d7: "$225/day",
      kmIncluded: "150 km/day",
      extraKm: "$1.75/km over 150 km",
      security: "$2,000",
      ldw: "$60/day",
    },
  },
  {
    slug: "mercedes-s-class-2022",
    name: "2022 Mercedes-Benz S580",
    shortName: "Mercedes-Benz S580",
    tagline: "The benchmark luxury sedan",
    image: sclassFront.url,
    images: [
      sclassFront.url,
      sclassFrontAlt.url,
      sclassSide.url,
      sclassRear.url,
      sclassWheel.url,
      sclassCockpit.url,
      sclassDash.url,
      sclassConsole.url,
      sclassDriverDoor.url,
      sclassPassengerDoor.url,
      sclassRearSeats.url,
      sclassRearDoor.url,
      sclassRearDoorInt.url,
      sclassRearPano.url,
      sclassRearPano2.url,
      sclassTrunkInt.url,
    ],
    category: "Ultra Luxury Sedan",
    pricePerDay: 395,
    specs: [
      { label: "Engine", value: "4.0L V8 Biturbo" },
      { label: "Horsepower", value: "496 hp" },
      { label: "Seats", value: "5" },
      { label: "Drive", value: "4MATIC AWD" },
    ],
    description:
      "Every detail considered. The S-Class wraps you in hand-stitched Nappa, ambient lighting, and the most advanced driver tech Mercedes builds.",
    rates: {
      h24: "$395/day",
      h48: "$295/day",
      d36: "$250/day",
      d7: "$225/day",
      kmIncluded: "150 km/day",
      extraKm: "$1.75/km over 150 km",
      security: "$2,000",
      ldw: "$60/day",
    },
  },
  {
    slug: "porsche-macan-2023",
    name: "2023 Porsche Macan",
    shortName: "Porsche Macan",
    tagline: "A sports car for every day",
    image: macanFront.url,
    images: [
      macanFront.url,
      macanFrontCenter.url,
      macanFrontQuarterClose.url,
      macanSide.url,
      macanExteriorSide.url,
      macanRearQuarter.url,
      macanRear.url,
      macanExteriorRear.url,
      macanDoor.url,
      macanFrontCabin.url,
      macanDriverView.url,
      macanConsole.url,
      macanConsoleDetail.url,
      macanPassengerDash.url,
      macanPassenger.url,
      macanRearSeats.url,
      macanTrunk.url,
    ],
    category: "Performance SUV",
    pricePerDay: 295,
    specs: [
      { label: "Engine", value: "2.0L Turbo I4" },
      { label: "Horsepower", value: "261 hp" },
      { label: "Seats", value: "5" },
      { label: "Drive", value: "AWD" },
    ],
    description:
      "Tight, agile, and unmistakably Porsche. The Macan offers SUV practicality with sports-car instincts.",
    rates: {
      h24: "$295/day",
      h48: "$230/day",
      d36: "$180/day",
      d7: "$150/day",
      kmIncluded: "150 km/day",
      extraKm: "$1.50/km",
      security: "$2,000",
      ldw: "$60/day",
    },
  },
  {
    slug: "bmw-m3-2023",
    name: "2023 BMW M3 Competition",
    shortName: "BMW M3",
    tagline: "Track-bred, street-ready",
    image: m3,
    category: "Performance Sedan",
    pricePerDay: 295,
    specs: [
      { label: "Seats", value: "5" },
      { label: "Engine", value: "3.0L Twin-Turbo I6" },
      { label: "Horsepower", value: "503 hp" },
      { label: "0-60 mph", value: "3.8 s" },
      { label: "Drive", value: "RWD" },
    ],
    description:
      "Five seats, four doors, and a back end that loves to dance. The M3 Competition is BMW's most uncompromising sedan.",
    rates: {
      h24: "$295/day",
      h48: "$275/day",
      d36: "$250/day",
      d7: "$225/day",
      kmIncluded: "150 km/day",
      extraKm: "$1.50/km",
      security: "$2,000",
      ldw: "$60/day",
    },
  },
  {
    slug: "bmw-m440-2021",
    name: "2021 BMW M440i",
    shortName: "BMW M440i",
    tagline: "Effortless coupe, big inline-six character",
    image: m440Front.url,
    images: [
      m440Front.url,
      m440Side.url,
      m440RearQuarter.url,
      m440Rear.url,
      m440Cockpit.url,
      m440PassengerDash.url,
      m440CenterDash.url,
      m440Infotainment.url,
      m440Console.url,
      m440Door.url,
      m440RearSeats.url,
    ],
    category: "Sport Coupe",
    pricePerDay: 295,
    specs: [
      { label: "Seats", value: "4" },
      { label: "Engine", value: "3.0L Turbo I6 Mild-Hybrid" },
      { label: "Horsepower", value: "382 hp" },
      { label: "0-60 mph", value: "4.3 s" },
      { label: "Drive", value: "xDrive AWD" },
    ],
    description:
      "Finished in deep gloss black. The M440i hits the sweet spot: fast, refined, and stylish. A coupe that flatters every drive.",
    rates: {
      h24: "$295/day",
      h48: "$250/day",
      d36: "$200/day",
      d7: "$150/day",
      kmIncluded: "150 km/day",
      extraKm: "$1.50/km",
      security: "$2,000",
      ldw: "$60/day",
    },
  },
  {
    slug: "bmw-x1-2023",
    name: "2023 BMW X1 xLine",
    shortName: "BMW X1",
    tagline: "Black on black, compact luxury SUV",
    image: x1,
    images: [
      x1,
      x1Side.url,
      x1FrontQuarter.url,
      x1Front.url,
      x1Wheel.url,
      x1Interior.url,
      x1DriverView.url,
      x1Dash.url,
      x1Door.url,
      x1RearSeats.url,
      x1Trunk.url,
      x1Sunroof.url,
    ],
    category: "Luxury Compact SUV",
    pricePerDay: 200,
    specs: [
      { label: "Engine", value: "2.0L Turbo I4" },
      { label: "Horsepower", value: "241 hp" },
      { label: "Seats", value: "5" },
      { label: "Drive", value: "xDrive AWD" },
    ],
    description:
      "Black on black with the xLine package. The X1 delivers BMW's signature drive in a nimble, city-friendly footprint: premium materials, modern tech, and effortless all-weather grip.",
    rates: {
      h24: "$200/day",
      h48: "$150/day",
      d36: "$100/day",
      d7: "$75/day",
      kmIncluded: "150 km/day",
      extraKm: "$1.50/km",
      security: "$2,000",
      ldw: "$60/day",
    },
  },
];

// One display order for the home fleet, fleet page, rates, and structured listings.
const fleetOrder = [
  "cadillac-escalade-2023",
  "bmw-x7-m60i-2024",
  "mercedes-s-class-2022",
  "porsche-macan-2023",
  "range-rover-p530-lwb-2024",
  "bmw-m440-2021",
  "bmw-x1-2023",
  "bmw-m3-2023",
];

export const cars: Car[] = [...inventory].sort(
  (a, b) => fleetOrder.indexOf(a.slug) - fleetOrder.indexOf(b.slug),
);

export const getCar = (slug: string) => cars.find((c) => c.slug === slug);
